import React from 'react';

interface VenerePlannerProps {
  size?: number;
  color?: string;
  className?: string;
}

const VenerePlanner: React.FC<VenerePlannerProps> = ({ size = 24, color = 'currentColor', className }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 2000 2000"
    fill={color}
    className={className}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M1425.84,361.24h-106.46c0-58.69-47.77-106.46-106.46-106.46h-425.84c-58.69,0-106.46,47.77-106.46,106.46h-106.46c-88.03,0-159.69,71.66-159.69,159.69v106.46c0,29.41,23.82,53.23,53.23,53.23s53.23-23.82,53.23-53.23v-106.46c0-29.34,23.89-53.23,53.23-53.23h106.46c0,58.69,47.77,106.46,106.46,106.46h425.84c58.69,0,106.46-47.77,106.46-106.46h106.46c29.34,0,53.23,23.89,53.23,53.23v1064.59c0,29.34-23.89,53.23-53.23,53.23h-851.67c-29.34,0-53.23-23.89-53.23-53.23v-745.22c0-29.41-23.82-53.23-53.23-53.23s-53.23,23.82-53.23,53.23v745.22c0,88.03,71.66,159.69,159.69,159.69h851.67c88.03,0,159.69-71.66,159.69-159.69V520.93c0-88.03-71.66-159.69-159.69-159.69ZM1212.92,467.7h-425.84v-106.46h425.84v106.46ZM680.62,1212.92c-29.41,0-53.23-23.82-53.23-53.23s23.82-53.23,53.23-53.23h76.32l144.19-240.33c9.71-16.17,27.68-26.02,46.24-25.82,18.9.2,36.26,10.45,45.64,26.81l147.18,257.56,21.09-84.37c5.92-23.69,27.21-40.32,51.63-40.32h106.46c29.41,0,53.23,23.82,53.23,53.23s-23.82,53.23-53.23,53.23h-64.87l-43.18,172.6c-5.26,21.09-22.82,36.86-44.31,39.79-2.46.4-4.92.53-7.32.53-18.9,0-36.66-10.11-46.24-26.81l-167.87-293.69-112.91,188.24c-9.58,16.04-26.88,25.82-45.58,25.82h-106.46Z"/>
  </svg>
);

export default VenerePlanner; 